export const FEATURE_KEYS = {
  BETTIE_BETA_USER: 'bettie_beta_user',
  CAMPAIGN_BANNER: 'campaign_banner',
  ADMIN: 'admin',
  BETTIE_REWARDS: 'bettie_rewards',
  AD_POPCORN: 'ad_popcorn',
  FIND_BUDDY: 'find_buddy',
  CARD_REVIEW: 'card_review',
  BETTIE_PROFILE_CHANGE: 'bettie_profile_change',
  SCENE_BETA: 'scene_beta',
  BETTIE_LETTER: 'bettie_letter'
} as const;

export type FeatureKey = (typeof FEATURE_KEYS)[keyof typeof FEATURE_KEYS];
